import React from 'react';
import { motion } from 'framer-motion';
export const PricingBlock = () => {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.5,
    duration: 0.8
  }} className="flex flex-col items-center justify-center space-y-2 my-8" data-id="element-182">
      <div className="inline-flex items-center justify-center px-3 py-1 mb-2 text-xs font-bold tracking-widest text-cosmic-900 uppercase bg-amber-400 rounded-full" data-id="element-183">
        75% Descuento
      </div>
      <div className="flex items-baseline space-x-4" data-id="element-184">
        <span className="text-2xl text-gray-500 line-through font-serif decoration-red-500/50 decoration-2" data-id="element-185">
          $108 USD
        </span>
        <span className="text-5xl md:text-6xl font-serif font-bold text-amber-400 drop-shadow-[0_0_15px_rgba(245,197,66,0.3)]" data-id="element-186">
          $27 USD
        </span>
      </div>
    </motion.div>;
};